import { render, staticRenderFns } from "./TreeTab.vue?vue&type=template&id=641c2b0b&scoped=true&"
import script from "./TreeTab.vue?vue&type=script&lang=js&"
export * from "./TreeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c2b0b",
  null
  
)

export default component.exports